import * as React from "react"
import { CopyableText } from "./copyable-text"
import { cn } from "../../lib/utils"

export interface CopyableIdProps {
  /** Full id value to copy */
  value: string
  /** Optional class name for the trigger */
  className?: string
  /** How many characters from the end of the id to display */
  visibleChars?: number
}

export function CopyableId({
  value,
  className,
  visibleChars = 6,
}: CopyableIdProps) {
  const display = value.slice(-visibleChars)

  return (
    <CopyableText
      value={value}
      className={cn(
        "text-xs font-mono text-muted-foreground justify-start px-0 py-0",
        className
      )}
    >
      <code className="break-all">...{display}</code>
    </CopyableText>
  )
}

